import { Options, Vue } from 'vue-class-component';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { FilePreviewData } from './file-preview-data';

@Options({
  components: {
    ErrorIndicator,
    LoadingIndicator,
  },
})
export default class FilePreview extends Vue {
  private blob: any;
  private documentURL: string = null as any;
  private dataLoaded = false;

  @Prop({ required: true, default: -1 })
  private state!: number;

  @Prop({ required: true, default: false })
  private showPreview!: boolean;

  @Prop()
  private previewFile!: FilePreviewData;

  @Prop({ default: false })
  private disableBackgroundScroll!: boolean;

  @Watch('previewFile')
  private onPreviewFileChanged(): void {
    this.createBlob();
  }

  created(): void {
    if (this.disableBackgroundScroll) {
      const el: HTMLElement = document.body;
      el.classList.add('disableScroll');
    }
  }

  beforeUnmount(): void {
    if (this.disableBackgroundScroll) {
      const el: HTMLElement = document.body;
      el.classList.remove('disableScroll');
    }

    try {
      window.URL.revokeObjectURL(this.documentURL);
    } catch (err) {
      console.log(err);
    }
  }

  private createBlob(): void {
    this.blob = new Blob([this.previewFile.FileStream], {
      type: this.previewFile.ContentType,
    });
    this.documentURL = window.URL.createObjectURL(this.blob);
  }

  private download() {
    const downloadLink = document.createElement('a');
    const fileName = this.viewingFile.FileName;

    downloadLink.href = this.documentURL;
    downloadLink.download = fileName as string;
    downloadLink.click();
  }

  private closePreview() {
    this.$emit('closePreview');
  }

  private osType(): string {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = '';

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  private detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  private isIOS(): boolean {
    return this.osType() === 'iOS';
  }

  get showDownloadButton(): boolean {
    const isIE = this.detectIE();
    if (typeof isIE === 'number' && isIE >= 12) {
      return true;
    } else if (isIE) {
      return true;
    } else if (this.osType() === 'iOS') {
      return true;
    } else {
      return false;
    }
  }

  get viewingFile(): FilePreviewData {
    return this.previewFile ? this.previewFile : new FilePreviewData();
  }

  get viewMode(): number {
    try {
      if (this.previewFile.FileExtension?.toLocaleLowerCase() === 'pdf') {
        return 1;
      } else {
        const fileType: string[] = ['png', 'jpg', 'bmp', 'jpeg'];
        const fileExtension = this.previewFile.FileExtension?.toLocaleLowerCase() || '';
        return fileType.indexOf(fileExtension) >= 0 ? 2 : 3;
      }
    } catch (e) {
      return -1;
    }
  }
}
